import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, watch, provide, onMounted, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useEventListener, usePageVisibility } from '@vant/use';
import { Local } from '@/locales/index';
import ws from '@/connect';
import { useAudio, useHelpTool } from "@/hooks";
import { useSettingsStore,useUserStore, useAccountStore, usePopupStore, useReddotStore, useGameStore } from '@/store'
import IOSWebApp from '@/components/IOSWebApp.vue';
import Reward from '@/components/Reward.vue';
import InAppFrame from '@/components/InAppFrame';
import GameFrame from '@/components/GameFrame';
import BindWallet from '@/components/BindWallet';
import AgeVerifiction from './components/AgeVerifiction.vue';
import Document from '@/components/Document.vue';
import TransactionPassword from '@/view/user/components/TransactionPassword/index';
import LuckySpin from '@/components/LuckySpin/index.vue';
import MyToast from '@/plugins/component/MyToast';
import MyDialog from '@/plugins/component/MyDialog';
import packageJson from '/package.json';
import { saveInviteCode } from '@/api';


export default {
  __name: 'App',
  setup(__props) {

const { playAudio } = useAudio();
const pageVisibility = usePageVisibility();

const { doShare, showKycSuspendDialog } = useHelpTool()

const settingsStore = useSettingsStore()
const userStore = useUserStore()
const accountStore = useAccountStore();
const popupStore = usePopupStore();
const { showReward, showInAppFrame, showGameFrame, showAgeVerifiction, showDocument, showBindWallet,
  showTransactionPassword, showLuckySpin } = storeToRefs(popupStore);
const redDotStore = useReddotStore();
const gameStore = useGameStore();

watch(pageVisibility, (newValue, oldValue) => {
  if (newValue === 'visible') {
    userStore.loadUserInfo({ userBack: true }, () => {
      if (!showGameFrame.value) { //不在游戏中时 切换页面刷新余额
        accountStore.fetchBalance();
      }
    }, () => {
      redDotStore.$reset();
    });
  }
})

onMounted(() => {
  // 设置语言
  let lang = navigator.browserLanguage || navigator.language;
  let langList = ['en-US', 'vi-VN']
  if (langList.indexOf(lang) < 0) {
    lang = langList[0]
  }
  Local(lang);

  let search = window.location.search.split('?')[1];
  let urlString = search ? search.split('&') : [];
  const urlParam = {};
  for (var i = 0; i < urlString.length; i++) {
    var _param = urlString[i].split('=');
    urlParam[_param[0]] = decodeURIComponent(_param[1]);
  }
  // 保存邀请码
  if (urlParam.code) {
    let registerCode = decodeURIComponent(decodeURIComponent(urlParam.code))
    settingsStore.setRegisterCode(registerCode);
  }
  saveInviteCode(urlParam).then(res => {})

  settingsStore.checkAppVersion();

  userStore.loadUserInfo({}, (userData) => {
    init(userData);
  });

  // analytics ga4 传送app版本
  gtag('set', 'user_properties', { 'app_version': packageJson.version  });

  setTimeout(() => {
    settingsStore.initShowSetting();
  }, 3000)
})

const init = (userData) => {
  //analytics ga4 登录注册后用于传送uid
  gtag('set', { 'user_id': userData.uid });

  gtag('event', 'login');
  
  if (userData.onlyKyc) {
    showKycSuspendDialog({ noClose: true });
  }
  accountStore.fetchBalance(); // 获取余额
  redDotStore.fetchData(); // 获取红点数量
  gameStore.fetchGameLikeMap(); // 缓存热门游戏
  settingsStore.fetchDepositProduct(); // 缓存支付信息

  ws.connect();
  // 注册websocket回调方法
  ws.registerCallBack('refresh.cache', (data) => {
    if (data === 'rechargeInfo') {
      settingsStore.fetchDepositProduct();
    } else if (data === 'badgeData') {
      redDotStore.fetchData();
    }
  })
}

provide('myToast', MyToast);
provide('myDialog', MyDialog);
provide('userHelper', { init });

// 自动播放背景音乐
// useEventListener(
//   'click',
//   () => {
//     playAudio('bgm');
//   },
//   { target: document.body },
// );

// 添加postMessage监听
useEventListener('message', async (event) => {
  // 安全起见，验证 origin（此处简化为 '*')
  if (event.data.type === 'REQUEST_SHARE') {
    doShare();
  }
});

return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_van_config_provider = _resolveComponent("van-config-provider")

  return (_openBlock(), _createBlock(_component_van_config_provider, {
    style: { height: '100%' },
    theme: "dark"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(IOSWebApp),
      (_unref(showReward))
        ? (_openBlock(), _createBlock(Reward, {
            key: 0,
            onOnClose: _cache[0] || (_cache[0] = $event => (_unref(popupStore).set('showReward', false)))
          }))
        : _createCommentVNode("", true),
      (_unref(showAgeVerifiction))
        ? (_openBlock(), _createBlock(AgeVerifiction, {
            key: 1,
            onOnClose: _cache[1] || (_cache[1] = $event => (_unref(popupStore).set('showAgeVerifiction', false)))
          }))
        : _createCommentVNode("", true),
      (_unref(showDocument))
        ? (_openBlock(), _createBlock(Document, {
            key: 2,
            onOnClose: _cache[2] || (_cache[2] = $event => (_unref(popupStore).set('showDocument', false)))
          }))
        : _createCommentVNode("", true),
      (_unref(showInAppFrame))
        ? (_openBlock(), _createBlock(_unref(InAppFrame), {
            key: 3,
            onOnClose: _cache[3] || (_cache[3] = $event => (_unref(popupStore).closeUrlInFrame()))
          }))
        : _createCommentVNode("", true),
      (_unref(showGameFrame))
        ? (_openBlock(), _createBlock(_unref(GameFrame), {
            key: 4,
            onOnClose: _cache[4] || (_cache[4] = $event => (_unref(popupStore).closeGameFrame()))
          }))
        : _createCommentVNode("", true),
      (_unref(showBindWallet))
        ? (_openBlock(), _createBlock(_unref(BindWallet), {
            key: 5,
            onOnClose: _cache[5] || (_cache[5] = $event => (_unref(popupStore).set('showBindWallet', false)))
          }))
        : _createCommentVNode("", true),
      (_unref(showTransactionPassword))
        ? (_openBlock(), _createBlock(_unref(TransactionPassword), {
            key: 6,
            onOnClose: _cache[6] || (_cache[6] = $event => (_unref(popupStore).set('showTransactionPassword', false)))
          }))
        : _createCommentVNode("", true),
      (_unref(showLuckySpin))
        ? (_openBlock(), _createBlock(LuckySpin, {
            key: 7,
            onOnClose: _cache[7] || (_cache[7] = $event => (_unref(popupStore).closeLuckySpin()))
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

}